<script>
import { cdmMethods } from '@state/helpers'
import _ from 'lodash'

export default {
  props: {
    cdmId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loadingError: null,
      loading: true,
      pagination: {
        rowsPerPage: 25,
      },
      items: [],
      totalData: 0,
      fields: [],
    }
  },
  computed: {
    sortedActiveFields() {
      var fields = this.fields.filter(x => x.showInTable === true)
      return fields.sort(function(a, b) {
        return a.order - b.order
      })
    },
    headers() {
      return this.sortedActiveFields.map(field => {
        return { text: field.caption || field.name, value: field.name }
      })
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
  },
  created() {
    this.getDataFromApi = _.debounce(this.getDataFromApi, 500)
  },
  methods: {
    ...cdmMethods,
    getDataFromApi() {
      this.loading = true

      return this.getRevUsageFields()
        .then(fields => {
          this.fields = fields.fields

          return this.getRevUsage({
            cdmId: this.cdmId,
            queryTerms: { ...this.pagination },
          })
            .then(data => {
              this.loading = false

              this.totalData = data.totalCount
              this.items = data.revUsage
            })
            .catch(error => {
              this.loading = false
              this.loadingError = error.response.data
            })
        })
        .catch(error => {
          this.loading = false
          this.loadingError = error.response.data
        })
    },
  },
}
</script>

<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalData"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear
          slot="progress"
          color="blue"
          indeterminate
        ></v-progress-linear>

        <template slot="no-data">
          <v-alert :value="loadingError" color="error" icon="warning">{{
            loadingError
          }}</v-alert>
          <v-alert :value="!loadingError" color="info" icon="info"
            >No Data Available</v-alert
          >
        </template>

        <template slot="items" slot-scope="props">
          <td v-for="field in sortedActiveFields" :key="field.id">
            {{ props.item[field.name] }}
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
